module.exports = __webpack_public_path__ + "static/0-6e8125c9b69064db55573a4fde7ed121.png";